<template>
  <div class="search-page c-layout">
    <div class="page-title">{{ $t('search.title') }}</div>
    <div class="page-container">
      <div class="page-right w-100">
        <div class="search-block">
          <input type="text" v-model="keyword">
          <div class="btn btn-orange" @click="handleSearch">{{ $t('search.search_text') }}</div>
        </div>
        <div v-loading="loading">
          <div class="goods-list-0 c-layout" v-show="list.length>0">
            <GoodsItem :item="item" v-for="(item,index) in list" :key="index" @addcart="handleOpenAddCartDrawer"/>
          </div>
          <div class="no-data" v-show="list.length==0">
            {{ $t('search.search_placeholder') }}
          </div>
        </div>

        <!-- <Pagination
          v-if="list"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @handleCurrentChange="handleCurrentChange"
          @handlePageIndex="handlePageIndex"
        /> -->
        <Pagination
          v-show="list.length>0"
          :pageSize="count"
          :pages="page"
          :total="total"
          :listLoading="loading"
          @handelPaginationChange="handleCurrentChange"
        />
      </div>
    </div>
    <AddCartDrawer ref="drawer"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GoodsItem from "@/components/GoodsItem";
import { searchProduct } from '../../api/index.js'
import Pagination from '../../components/Pagination/NewPagination.vue'
import AddCartDrawer from '../../components/AddCardDrawer/index.vue'

  export default {
    name: 'search-page',
    data() {
      return {
        keyword: '',
        page: 0,
        count: 10, //每页显示多少条
        loading: false,
        list: [],
        total: 0
      }
    },
    components: {
      Pagination,GoodsItem,AddCartDrawer
    },
    computed: {
      ...mapState(['userInfo']),
    },
    mounted() {

    },
    methods: {
      async getList(data={}) {
        if(!data.page) {
          this.page++;
        }  
        
        if(this.keyword == '') {
          this.$message({
            message: this.$t('alert_message.insert_search_product_name'),
            type: 'warning'
          });
          return
        }
        this.loading = true;
        const loadingInstance = this.$loading();
        console.log(this.userInfo);
        const postData = {
          pages: this.page,
          count: this.count,
          store_id: this.userInfo?this.userInfo.user.store_id:1,
          keyword: this.keyword,
        }
        const res = await searchProduct(postData);
        console.log(res);
        this.list = res.list;
        this.total = res.total;
        loadingInstance.close();
        this.loading = false;
      },
      handleSearch() {
        this.page = 0;
        this.getList();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getList({ page: val });
      },
      async handleOpenAddCartDrawer(pid) {
        // this.choosePid = pid;
        this.$refs.drawer.handleOpenAddCartDrawer(pid);
      },
    }
  }
</script>

<style lang="less" scoped>
.search-page {
  min-height: 60vh;
  .search-block {
    display: flex;
    width: 80%;
    margin: auto;
    margin-bottom: 40px;
    .btn {
      width: 120px;
    }
  }
  .goods-list-0 {
    display: flex;
    flex-wrap: wrap;
    .goods-item-comp {
      margin-right: 29px;
    }
    .goods-item-comp:nth-child(4n) {
      margin-right: 0;
    }
  }

  @media (max-width: 992px) {
    .goods-list-0 {
      padding: 0 20px;
      .goods-item-comp {
        &:nth-child(2n-1) {
          padding-right: 15px;
          }
        &:nth-child(2n) {
          padding-left: 15px;
        }
      }
    }
  }
}
</style>